import { render, staticRenderFns } from "./tip.mpx?vue&type=template&id=4ec50279&isComponent&outputPath=components%2Ftip1826fcdc%2Findex"
import script from "./tip.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ftip1826fcdc%2Findex"
export * from "./tip.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ftip1826fcdc%2Findex"
import style0 from "./tip.mpx?vue&type=style&index=0&id=4ec50279&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_1826fcdc%22%7D&isComponent&outputPath=components%2Ftip1826fcdc%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports